import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { titleTemplate } from 'utils/seoUtils';
import { SportHomePageContent } from "../../Common/pages/SportHomePageContent";

export default class GreyhoundRacingHomePage extends Component {
  static propTypes = {
    location: PropTypes.object
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="greyhounds"
      title="Greyhound News | Results & Racecards"
      location={ location }
      helmetProps={ {titleTemplate: titleTemplate.plain} }
      rightColumnContent={
        ["mostReadAll", "topMpu", "ocWidget", "racingTips", "horseRacingNextRaceOff", "footballTips"]
      }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/containers/GreyhoundRacingHomePage.js